import { render, staticRenderFns } from "./drawer_allergy_history.vue?vue&type=template&id=6e79e8c3&scoped=true&"
import script from "./drawer_allergy_history.vue?vue&type=script&lang=js&"
export * from "./drawer_allergy_history.vue?vue&type=script&lang=js&"
import style0 from "./drawer_allergy_history.vue?vue&type=style&index=0&id=6e79e8c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79e8c3",
  null
  
)

export default component.exports